<template>
    <div :class="s.dropZone">
        <div :class="s.dropZoneContainer">
            <span :class="s.dropZoneTitle">Доступен выбор только одного файла.<br/>Удалите выбранный файл, если хотите загрузить другой.</span>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import style from "./style.module.scss";

export default Vue.extend({
    name: "drop-zone-disabled",
    components: {},
    props: {},
    data() {
        return {
            s: style,
        };
    },
    methods: {},
});
</script>
